import React from 'react';
import { Alert, Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'react-bootstrap';
import { Link } from 'react-router';

import { useForm } from 'react-hook-form';

interface LoginFormValues {
  username: string;
  password: string;
  rememberMe: boolean;
}

export interface ILoginModalProps {
  showModal: boolean;
  loginError: boolean;
  loginForbidden?: boolean;
  handleLogin: (username: string, password: string, rememberMe: boolean) => void;
  handleClose: () => void;
}

const LoginModal = (props: ILoginModalProps) => {
  const login = ({ username, password, rememberMe }: LoginFormValues) => {
    props.handleLogin(username, password, rememberMe);
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<LoginFormValues>({ mode: 'onTouched' });

  const { loginError, loginForbidden, handleClose } = props;

  const handleLoginSubmit = e => {
    handleSubmit(login)(e);
  };

  return (
    <Modal show={props.showModal} onHide={handleClose} backdrop="static" id="login-page" autoFocus={false}>
      <Form onSubmit={handleLoginSubmit}>
        <ModalHeader id="login-title" data-cy="loginTitle" closeButton>
          Iniciar la sesión
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              {loginError &&
                (loginForbidden ? (
                  <Alert variant="danger" data-cy="loginError">
                    <strong>Acceso denegado.</strong> Solo los administradores pueden ingresar al backoffice.
                  </Alert>
                ) : (
                  <Alert variant="danger" data-cy="loginError">
                    <strong>¡El inicio de sesión ha fallado!</strong> Por favor, revise las credenciales e intente de nuevo.
                  </Alert>
                ))}
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="username">
                <Form.Label>Usuario</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nombre de usuario"
                  autoFocus
                  data-cy="username"
                  isInvalid={!!errors.username}
                  {...register('username', { required: 'El usuario no puede estar vacío.' })}
                />
                <Form.Control.Feedback type="invalid">{errors.username?.message}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Su contraseña"
                  data-cy="password"
                  isInvalid={!!errors.password}
                  {...register('password', { required: 'La contraseña no puede estar vacía.' })}
                />
                <Form.Control.Feedback type="invalid">{errors.password?.message}</Form.Control.Feedback>
              </Form.Group>
              <Form.Check
                className="mb-3"
                type="checkbox"
                id="rememberMe"
                label="Iniciar la sesión automáticamente"
                {...register('rememberMe')}
              />
            </Col>
          </Row>
          <div className="mt-1">&nbsp;</div>
          <Alert variant="warning">
            <Link to="/account/reset/request" data-cy="forgetYourPasswordSelector">
              ¿Ha olvidado su contraseña?
            </Link>
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={handleClose} tabIndex={1}>
            Cancelar
          </Button>{' '}
          <Button variant="primary" type="submit" data-cy="submit">
            Iniciar sesión
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default LoginModal;
